module.exports = __webpack_public_path__ + "static/media/expert-advice-v2.cacb7c63.svg";